// extracted by mini-css-extract-plugin
export default {"container":"product-swatch-description__container___1DWrb","finish":"product-swatch-description__finish___3Rjqe"};